import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Shop by Category
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            Browse our complete product categories and explore the best CSSBuy spreadsheet resources for every type of purchase
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative rounded-lg overflow-hidden aspect-[6/5] cursor-pointer"
            >
              <img
                src={cat.imageUrl}
                alt={`${cat.name} category on CSSBuy Spreadsheet`}
                title={`${cat.name} - CSSBuy Spreadsheet Category`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/10 to-transparent"></div>
              <div className="absolute inset-0 flex flex-col items-center justify-center">
                <h3 className="text-white text-xl md:text-2xl font-heading font-semibold mb-1">
                  {cat.name}
                </h3>
                <p className="text-white/70 text-xs md:text-sm font-label tracking-wide">
                  Browse on Kaspreadsheet
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}